import React, { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import api from '../components/api'
import { useEnunciadoContext } from '../context/enunciadoContext'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'


const Correcoes = (props) => {

    const formulario_id = props.formulario_id
    const origem = props.origem


    const [resultado, setResultado] = useState([])
    const { enunciado, setEnunciado } = useEnunciadoContext()
    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()


    const validacoes = () => {

        //console.log('verificado')
        //console.log('aaa')
        

        if (formulario_id) {

            var dataPost = {

                formulario_id: formulario_id,
                desafio: origem,

            }

            api.post('desafioValidaVarios', dataPost).then((result) => {

                
                setResultado(result.data.map((rs) =>

                    <tr onClick={() => {window.$('#modalValidacao').modal('show');setEnunciado(rs.enunciado)}} style={{ cursor: 'pointer'}}>
                        <td>
                            <center>
                            {rs.secao}
                            </center>
                        </td>
                        <td>
                            {rs.enunciado}
                        </td>
                        <td  style={{ textAlign: 'center', backgroundColor: rs.status == 'Erro' ? '#f29f99' : '#d7edca'}}>
                            {rs.status == 'Erro' ? 'Com pendência' : rs.status}
                        </td>
                    </tr>
                
                ))
                    


            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    useEffect(() => {

        validacoes()


    }, [formulario_id, verificaDesafio])

    return (

        <div>


            <div className="row">                               



                <div className="col-md-12">


                    <Table striped bordered hover>
                        
                        <thead>
                            <tr>
                                <th><center>Seção</center></th>
                                <th>Questão</th>
                                <th style={{ textAlign: 'center' }}>Situação</th>
                            </tr>
                        </thead>
                        
                        <tbody>
                           {resultado}
                        </tbody>
                    </Table>
                </div>

            </div>


        </div>
    )

}

export default Correcoes